export default "__VITE_ASSET__f742ae13__"